module.exports = "https://www.gc-qa.gnp.com.mx/4a4883455c2d7344d93a81a8ca0a6354.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_vida.svg
// module id = 695
// module chunks = 0